<template>
  <div class="page page-drivers">
    <h3>Водитель</h3>
    <ActionBar
      :isEditing="isEditing"
      @changeAction="changeDriver"
      @cancelAction="cancelDriverChanges"
      @deleteAction="deleteDriver"
      @saveAction="updateDriver"
    />
    <br/>
    <DriverEditForm
      v-if="isEditing"
      class="driver-view-edit"
      :driver="driver"
    />
    <DriverShowForm
      v-else
      class="driver-view-edit"
      :driver="driver"
    />
    <div class="driverDocs">
      <h5>Документы водителя<router-link :to="`/drivers/${id}/docs/create`" class="btn btn-primary add-doc">Добавить</router-link></h5>
      <br/>
      <LightBox
        v-if="showDetailImage"
        @actionClose="showDetailImage = false"
        :scan="currentScan"
      />
      <div v-if="driver.documents">
        <Document v-for="document of driver.documents" :key="document.id"
          :viewComponent="DocumentTypes[document.type].viewComponent"
          :title="DocumentTypes[document.type].tabs.title"
          :scansTitle="DocumentTypes[document.type].tabs.scansTittle"
          :document="document"
          @actionDetailImage="detailImage(currentScan)"
          @actionDelte="deleteDocument(document.id)"
          @actionUpdate="$router.push(`/drivers/${id}/docs/${document.id}/update`)"
        />
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable camelcase */

import Swal from 'sweetalert2'
import deepAssign from 'assign-deep'
import DocumentsAPI from '@/api/driver-documents'
import DriversAPI from '@/api/drivers'
import DocumentTypes from '@/views/driverDocuments/types'
import { mapMutations } from 'vuex'

export default {
  name: 'DriverPage',
  props: ['id'],
  data () {
    return {
      isUpdating: false,
      prevDriver: null,
      driver: {
        id: this.id,
        last_name: '',
        middle_name: '',
        first_name: '',
        phone: '',
        documents: []
      },
      DocumentTypes,
      isEditing: false,
      currentScan: null,
      showDetailImage: false
    }
  },
  mounted () {
    this.loadData()
  },
  methods: {
    updateDriver () {
      if (this.isUpdating) {
        return
      }
      this.isUpdating = true
      DriversAPI.updateItem(this.driver)
        .then(driver => {
          this.driver = { ...this.driver, ...driver.model }
          this.isUpdating = false
          this.isEditing = false
        })
        .catch(text => {
          this.isUpdating = false
          Swal.fire({
            icon: 'error',
            title: 'Ошибка',
            html: text.message
          })
        })
    },
    loadData () {
      DriversAPI.getItem({
        id: this.id,
        queryWith: ['documents']
      })
        .then(response => {
          this.driver = response
          this.loadScans()
        })
    },
    loadScans () {
      this.clearItems()
      this.setModel('DriverDocument')
      this.driver.documents.forEach(element => {
        DocumentsAPI.getScans(element.id).then(result => {
          element.scans = result
          this.pushItems({ scans: result, documentId: element.id })
        })
          .catch(text => {
            Swal.fire({
              icon: 'error',
              title: 'Ошибка сервера',
              text
            })
          })
      })
    },
    deleteDocument (documentId) {
      DocumentsAPI.removeItem(documentId)
        .then(() => this.loadData())
        .catch(text => {
          Swal.fire({
            icon: 'error',
            title: 'Ошибка',
            html: text.message
          })
        })
    },
    changeDriver () {
      this.prevDriver = deepAssign({}, this.driver)
      this.isEditing = true
    },
    cancelDriverChanges () {
      this.driver = this.prevDriver
      this.isEditing = false
    },
    deleteDriver () {
      DriversAPI.removeItem(this.driver.id)
        .then(() => {
          this.$router.push('/drivers')
        })
        .catch(text => {
          Swal.fire({
            icon: 'error',
            title: 'Ошибка',
            html: text.message
          })
        })
    },
    ...mapMutations('taxi/scans', [
      'pushItems',
      'clearItems',
      'setModel'
    ])
  }
}
</script>

<style scoped>
  .add-doc {
    float: right;
  }
  .page-drivers {
    width: 98%;
    padding-bottom: 4rem;
    padding-top: 2.5rem;
  }

</style>
